// Seri numarası kontrol isteği
export interface SerialNumberCheckRequest {
  SerialNumber: string
  DealerCode: string
  CompanyCode?: string
}

// Ürün bilgisi
export interface ProductInfo {
  ProductCode: string
  ProductName: string
  Brand: string
  Model: string
  Description: string
  Price: number
  Currency: string
  ImageUrl?: string
}

// Fatura bilgisi
export interface InvoiceInfo {
  InvoiceNumber: string
  InvoiceDate: string
  EInvoiceNumber: string
  CompanyCode: string
  CompanyName: string
}

// Kredi uygunluk durumu
export interface CreditEligibility {
  IsEligible: boolean
  Reason: 'ELIGIBLE' | 'ALREADY_CREDITED' | 'NOT_ELIGIBLE' | 'NOT_FOUND'
  MaxCreditAmount: number
  MinCreditAmount: number
  Message?: string
}

// Seri numarası kontrol yanıtı
export interface SerialNumberCheckResponse {
  IsValid: boolean
  ProductInfo: ProductInfo | null
  InvoiceInfo: InvoiceInfo | null
  CreditEligibility: CreditEligibility
  ErrorMessage: string | null
}

// Tek ürün bilgisi (birden fazla ürün desteklendiğinde kullanılır)
export interface SerialCreditProductItem {
  SerialNumber: string
  CreditAmount: number // Orijinal döviz cinsinden tutar
  CreditAmountTL: number // TL karşılığı
  CurrencyType: string // Orijinal para birimi (USD, EUR, TL)
  ExchangeRate: number // Uygulanan döviz kuru
  ProductCode: string
  InvoiceNumber: string
  ProductName?: string
  Brand?: string
  IsManual?: boolean // Manuel olarak girildi mi
}

// Alışveriş kredisi başvuru isteği - birden fazla ürün destekler
export interface SerialCreditApplicationRequest {
  // Geriye dönük uyumluluk için tekil alanlar (tek ürün durumunda)
  SerialNumber?: string
  CreditAmount?: number
  CreditAmountTL?: number
  CurrencyType?: string
  ExchangeRate?: number
  ProductCode?: string
  InvoiceNumber?: string
  // Birden fazla ürün desteği
  Products?: SerialCreditProductItem[]
  // Ortak alanlar
  CustomerGsmNumber: string // 5XXXXXXXXX formatında
  DealerCode: string
  CompanyCode: string
  TotalCreditAmount?: number // Toplam döviz tutarı
  TotalCreditAmountTL?: number // Toplam TL tutarı
  identitNumber?: string // T.C. kimlik numarası (isteğe bağlı)
  dob?: string // Doğum tarihi (isteğe bağlı)
}

// Alışveriş kredisi başvuru yanıtı
export interface SerialCreditApplicationResponse {
  Success: boolean
  PaymentId: string
  OrderId: string
  Status: string | null
  Amount: number
  Currency: string
  Timestamp: string | null
  Hash: string
  RedirectUrl: string
  ErrorCode: string | null
  ErrorMessage: string | null
  HtmlContent: string
  FormData?: any
  // Yeni alanlar - bekleyen başvuru kontrolü için
  Warning?: boolean
  CanCancel?: boolean
}

export interface CheckCreditResponse {
  Success: boolean
  ErrorCode: string | null
  ErrorMessage: string | null
  CheckCreditData: CheckCreditData[]
}

export interface CheckCreditData {
  logoPath: string
  acquirerId: string
  isSimulation: boolean
  displayStatus: boolean
  isNewCostumer: boolean
  applicationId: string
  bankName: string
  offers: CheckCreditOffers[]
}

export interface CheckCreditOffers {
  term: number
  interestRate: number
  installmentAmount: number
  totalPaymentAmount: number
  annualEffectiveInterestRate: number
  loanAmount: number
}

// Hata kodları
export const ErrorCodes = {
  CREDIT_ALREADY_USED: 'CREDIT_ALREADY_USED',
  SERIAL_NOT_FOUND: 'SERIAL_NOT_FOUND',
  NOT_ELIGIBLE: 'NOT_ELIGIBLE',
} as const

// Hata mesajları
export const ErrorMessages = {
  NOT_FOUND: 'Girilen seri numarasına ait bir kayıt bulunamadı.',
  ALREADY_CREDITED: 'Bu seri numarası ile daha önce kredi işlemi yapılmış.',
  CREDIT_ALREADY_USED: 'Bu seri numarası için bekleyen bir kredi başvurusu bulunmaktadır.',
  NOT_ELIGIBLE: 'Bu ürün için alışveriş kredisi kullanılamaz.',
  INVALID_GSM: 'Geçersiz telefon numarası. Telefon numarası 5 ile başlamalı ve 10 haneli olmalıdır.',
  NETWORK_ERROR: 'Bağlantı hatası oluştu. Lütfen tekrar deneyiniz.',
  UNKNOWN: 'Beklenmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.',
  EMPTY_SERIAL: 'Lütfen seri numarası giriniz.',
  MIN_SERIAL_LENGTH: 'Seri numarası en az 5 karakter olmalıdır.',
  INVALID_AMOUNT: 'Kredi tutarı belirlenen limitler arasında olmalıdır.',
  EXCHANGE_RATE_ERROR: 'Döviz kuru alınamadı. Lütfen sayfayı yenileyiniz.',
} as const

// Adım tipleri
export type StepType =
  | 'serial_input'
  | 'manual_product_entry'
  | 'product_info'
  | 'customer_info'
  | 'processing'
  | 'success'
  | 'error'
  | 'result_success'
  | 'result_fail'
  | 'result_pending'
  | 'success-credit'

// Kredi sonuç bilgisi
export interface CreditResultData {
  orderId: string
  authCode?: string
  refNum?: string
  amount?: number
  errorMessage?: string
}

export interface PriceLimitCategory {
  Category: string
  MaxPriceLimit?: number
  MinPriceLimit?: number
}
